import React, {useState} from "react";
import userApiClient from "../../../../common/apis/user/UserApiClient";
import {UserDto} from "../../../../common/apis/user/UserDto";
import {Button} from "../../../../components/button/Button";
import {CancelButton} from "../../../../components/button/CancelButton";
import Dialog from "../../../../components/dialogs/Dialog";
import DialogActions from "../../../../components/dialogs/DialogActions";
import DialogContent from "../../../../components/dialogs/DialogContent";
import DialogContentText from "../../../../components/dialogs/DialogContentText";
import DialogTitle from "../../../../components/dialogs/DialogTitle";
import {t} from "../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../CommonTranslationKey";
import {ErrorTranslationKey} from "../ErrorTranslationKey";
import Snackbar from "../snackbar/Snackbar";
import {UsersTranslationKey} from "./UsersTranslationKey";

interface UserActivationDialogProps {
    open: boolean;
    user?: UserDto;
    onClose: (activated: boolean) => void;
}

export default function UserActivationDialog(props: UserActivationDialogProps) {
    const {open, user, onClose} = props;

    const [inProgress, setInProgress] = useState(false);

    function activate() {
        if (user) {
            setInProgress(true);
            userApiClient.activateUserByLogin(user.login, true)
                    .then(() => {
                        Snackbar.success(t(CommonTranslationKey.DATA_SAVED_SUCCESSFULLY));
                        onClose(true);
                    })
                    .catch(() => {
                        Snackbar.success(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED));
                    })
                    .finally(() => setInProgress(false));
        }
    }

    return (
        <Dialog
                open={open}
                onClose={() => onClose(false)}
                aria-labelledby="simple-dialog-title">
            <DialogTitle id="simple-dialog-title"
                    title={t(UsersTranslationKey.ACTIVATE_USER_QUESTION_MARK)}
                    onDialogClosed={() => onClose(false)} />
            <DialogContent>
                <DialogContentText>
                    {t(UsersTranslationKey.USER_WILL_BE_ACTIVATED)}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={() => onClose(false)} disabled={inProgress}/>
                <Button label={t(UsersTranslationKey.ACTIVATE)}
                        onClick={() => activate()}
                        disabled={inProgress}
                        variant={"contained"}/>
            </DialogActions>
        </Dialog>
    )
}
